import { Pipe, PipeTransform } from '@angular/core';
import { AddressInfo } from '@moxi.gmbh/moxi-typescriptmodels';
import { formatAddressDisplay } from '@shared/utils';

@Pipe({
  name: 'formatAddressName',
  standalone: true
})
export class FormatAddressDisplayNamePipe implements PipeTransform {
  transform(value: AddressInfo): string {
    return formatAddressDisplay(value);
  }
}
